import { Box } from "@mui/material"
import { ClientModal } from "./ClientModal"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { ClientData, SectorData } from "../../types";
import { useAPI } from "../../hooks/useAPI";
import { useAuth } from "../../assets/contexts/AuthContext";

interface EditClientProps {
  sectors: SectorData[];
  refetchClients: () => void;
}

export const EditClient = ( { sectors, refetchClients }: EditClientProps) => {
  const { client_id } = useParams();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { fetchData } = useAPI();
  const [client, setClient] = useState<ClientData>({});
  const isLoading = useRef(false);
  const { isAuthenticated } = useAuth();

  const handleClose = () => {
    setOpen(false);
    navigate('/clients');
  }

  const handleSave = () => {
    navigate('/clients');
    refetchClients();
  }
  
  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      isLoading.current = true;

      fetchData(`/clients/${client_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setClient(data);
        setOpen(true);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })
    }
  }, [isAuthenticated, client_id]);

  return (
    <Box className="edit-client">
      <ClientModal open={open} handleClose={handleClose} handleSave={handleSave} sectors={sectors} client={client} />
    </Box>
  )
}
